import { map, pick, merge } from 'lodash-es';
import Log from 'web-sdk';
import { LogPageInfoProps } from 'web-sdk/types/src/log/types';
import { pageInfoList, ClickEvents, ExposeEvents, PAGE_INFO_FIELDS } from './config';
import { LOG_APP_ID, LOG_APP_NAME, LOG_BASE_URL } from './log';

type BaseTraceDataValue = string | number;

type TraceData = Record<string, BaseTraceDataValue>;
// 页面信息接口
interface PageInfo {
  event_tracking_id: string;
  event_tracking_ext?: TraceData;
  // 其他页面信息属性
  page_name?: string;
  page_path?: string;
  page_title?: string;
  [key: string]: unknown;
}

export interface LogEventExternalProps {
  path?: string;
  event_tracking: string; //埋点英文名
  event_tracking_id: string; // 埋点id
  event_tracking_ext?: object; // 拖展参数
  business1?: string;
  business2?: string;
  curr_page?: string; // 当前页面埋点英文名
  merge?: boolean; //默认为false，为true时会将event_tracking_id相同的事件合并上报（event_tracking_ext变成数组）
}

export interface LogExternalPropsPartial {
  app_id?: string;
  app_name?: string;
  ver?: string;
  uid?: string;
}

const env = process.env.NODE_ENV || 'production';

const external = {
  app_id: LOG_APP_ID,
  app_name: LOG_APP_NAME,
  ver: '1.0.0',
};
const config = {
  log_env: env, // test1
  configBaseURL: LOG_BASE_URL, // https://log.noxiaohao.com
  reportBaseURL:
    process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development' ? LOG_BASE_URL : '',
  defaultPageEvent: false,
};

class TrackPlugin {
  private log?: Log;

  constructor() {
    if (typeof window !== 'undefined') {
      try {
        // this.updatePageInfo()
        this.log = new Log(external, this.getPageInfoList(), config);
      } catch (e) {
        console.error('init log error: ', e);
      }
    }
  }

  public update(params: LogExternalPropsPartial) {
    this.log?.update(params);
  }

  // private updatePageInfo() {
  //   if (typeof window !== 'undefined') {
  //     pageInfoList.forEach((pageInfo) => {
  //       pageInfo.event_tracking_ext = this.getEventTrackingExt(pageInfo)
  //     })
  //   }
  // }

  private getPageInfoList(): LogPageInfoProps[] {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return map(pageInfoList, (pageInfo: any) =>
      pick(pageInfo, PAGE_INFO_FIELDS)
    ) as LogPageInfoProps[];
  }

  public click(eventId: keyof ClickEvents, ext?: TraceData) {
    try {
      const eventProps = ClickEvents[eventId];
      const { ...props } = eventProps;

      const extData = this.getEventTrackingExt(eventProps, ext);
      this.log?.click({
        ...props,
        event_tracking_ext: extData as Record<string, string>,
      });
    } catch (e) {
      console.error(e);
    }
  }
  // 页面浏览事件的额外动态参数配置
  public pageInfoParams(id: string, ext: TraceData) {
    const pageList = map(pageInfoList, (pageInfo: PageInfo) => {
      const obj = { ...pageInfo };
      if (id === pageInfo.event_tracking_id) {
        obj.event_tracking_ext = merge({}, pageInfo.event_tracking_ext, ext);
      }
      return obj;
    }) as LogPageInfoProps[];

    this.log = new Log(external, pageList, config);
  }

  public expose(eventId: keyof ExposeEvents, ext?: TraceData) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const eventProps: any = ExposeEvents[eventId];
      const { ...reset } = eventProps;
      const extData = this.getEventTrackingExt(eventProps, ext);
      const props = {
        ...reset,
        event_tracking_ext: extData as Record<string, string>,
      };
      this.log?.expose(props);
    } catch (e) {
      console.error(e);
    }
  }

  private getEventTrackingExt(props: LogEventExternalProps, ext?: object): object {
    const extData = merge({}, props.event_tracking_ext, ext);
    return extData;
  }
}

export const tracker: TrackPlugin = new TrackPlugin();
